<template>
  <div class="card-btn-container">
    <img src="../assets/image/icon-a.png" alt="" />
    <!-- <business-card ref="businessCard"></business-card> -->
  </div>
</template>

<script>
// import businessCard from "@/components/businessCard"
export default {
    components:{
        // businessCard
    },
  data() {
    return {};
  },
  methods:{
    openCard(){
      this.$refs.businessCard.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.card-btn-container {
  width: 50px;
  height: 50px;
  background-image: linear-gradient(179deg, #0057ff 0%, #2123ff 100%);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9;
  cursor: pointer;
  user-select: none;
  img {
    height: 25px;
    margin-bottom: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cardBtn.vue